module.exports = __webpack_public_path__ + "static/img/12.c38108a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Personas/12.png
// module id = OTG+
// module chunks = 0